import { Component, Input } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { notesValidationMessages, NotesValidator } from '@helios/validators'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'note-modal',
  templateUrl: './note-modal.component.html',
})
export class NoteModalComponent {
  private readonly _noteControl = new FormControl('', NotesValidator())

  @Input() set note(value: string) {
    const noteWithNewLine = value.replace(/(\\r\\n)|(\\n)/g, '\n')
    this._noteControl.setValue(noteWithNewLine)
  }

  @Input() modalTitle = ''

  form: FormGroup = new FormGroup({ note: this._noteControl })

  validationMessages = { notesValidationMessages }

  constructor(public activeModal: NgbActiveModal) {}

  onSubmit() {
    this.activeModal.close(this._noteControl.value)
  }

  /**
   * Just close the modal and reset the form
   */
  onCancel() {
    this.activeModal.dismiss()
  }
}
